import * as Yup from "yup";

const grupoTributarioValidator = Yup.object().shape({
  nome: Yup.string().required("Nome"),
  ativado: Yup.string().nullable(),
});

export default grupoTributarioValidator;
